const space = {
  "50": "0.25rem",
  // 4px
  "75": "0.5rem",
  // 8px
  "100": "0.75rem",
  // 12px
  "200": "1rem",
  // 16px
  "300": "1.5rem",
  // 24px
  "400": "2rem",
  // 32px
  "500": "2.5rem",
  // 40px
  "600": "3rem",
  // 48px
  "800": "4rem",
  // 64px
  "1200": "6rem"
  // 96px
};

export { space };
